export default __webpack_public_path__ + "static/media/split-bill-step-2@2x.19e69cc5.png";